/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useCallback } from 'react';

export const useLocalStorage = (key, initialValue = null) => {
  // pull the initial value from local storage if it is already set
  const [state, setState] = useState(() => {
    const exValue = localStorage.getItem(key);
    if (exValue) {
      return JSON.parse(exValue);
    }
    return initialValue;
  });

  // save the new value when it changes
  useEffect(() => {
    if (state) localStorage.setItem(key, JSON.stringify(state));
  }, [state]);

  // memoize a storage watcher callback back because everything in hooks should be memoized
  const storageWatcher = useCallback(
    (e) => {
      if (e.newValue) {
        // update ours if we
        setState((currState) => {
          const newDat = JSON.parse(e.newValue || 'null');
          return newDat === state ? newDat : currState;
        });
      }
    },
    [state]
  );

  // install the watcher
  useEffect(() => {
    window.addEventListener('storage', storageWatcher);
    // stop listening on remove
    return () => {
      window.removeEventListener('storage', storageWatcher);
    };
  }, [state]);

  return { state, setState };
};
